<template>
  <div>
    <v-app>
      <v-content>
        <v-container>
          <v-row class="mb-6" no-gutters>
            <b>事業概要</b>
          </v-row>
          <v-row class="mb-6">
            <v-col :cols="12" color="#DCDCDC">
              <v-card class="pa-4" outlined tile color="#DCDCDC">
                <img :width="50" :height="40" :src="guerrillalogo" />
                <b>依頼時の流れ</b>
              </v-card>
              <v-card class="pa-6" outlined tile>
                <ul class="flow">
                  <li>
                    <dl>
                      <dt><span class="icon">STEP.01</span>ご相談</dt>
                      <dd>
                        お客様の実現したいこと及び悩んでいることをお聞かせください。初回相談は2時間（無料）です。
                      </dd>
                    </dl>
                  </li>

                  <li>
                    <dl>
                      <dt><span class="icon">STEP.02</span>整理</dt>
                      <dd>
                        ヒアリングした課題/ビジネスアイディアを整理していきます。<br />本当に実現可能か？費用をかけてやる必要があるか？市場から求められているか？を細かく検討します。
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt><span class="icon">STEP.03</span>システム要件整理</dt>
                      <dd>
                        ニーズがあるプロダクトであると判断できたら、システムの要件整理をしていきます
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt><span class="icon">STEP.04</span>プロトタイプ開発</dt>
                      <dd>
                        ゲリラチーム体制を整備し、小規模なプロトタイプを開発。<br />リリース前のこの時点でも、実際にユーザにヒアリングをしつつニーズを拾っていきます
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt><span class="icon">STEP.05</span>初回リリース</dt>
                      <dd>
                        プロトタイプ開発を終え、実際に市場に投入。ここからが本番のゲリラ戦です。
                      </dd>
                    </dl>
                  </li>
                  <li>
                    <dl>
                      <dt><span class="icon">STEP.06</span>より具現化</dt>
                      <dd>
                        市場の反応を見ながら、競合分析をしつつ、プロトタイプを拡張していきます。<br />業界課題を変える革新的なものを目指しつつ、収益化もしていきます。
                      </dd>
                    </dl>
                  </li>
                </ul>
              </v-card>
            </v-col>
          </v-row>
          <br /><br />
          <p class="btn-positon">
            <a href="https://forms.gle/2ee784g8o1j61e7c9" class="btn"
              >ご相談はこちら</a
            >
          </p>
          <br /><br />
          <v-row class="mb-6">
            <v-col :cols="12" color="#DCDCDC">
              <v-card class="pa-4" outlined tile color="#DCDCDC">
                <img :width="50" :height="40" :src="guerrillalogo" />
                <b>弊社実践中のサービス事例</b>
              </v-card>
              <v-row class="mb-6">
                <v-col :cols="12" color="#DCDCDC">
                  <v-card class="pa-4" outlined tile color="#DCDCDC">
                    <b>弊社事業で培った知見をクライアント企業へ提供</b>
                  </v-card>
                  <v-card class="pa-6" outlined tile>
                    自社のスペースで培ったノウハウをもとに、教育事業を展開している法人様の技術顧問としての指導・支援を
                    行っております。単純なIT教育ではなく、いかに現場で付加価値を作り出すかに重点を置いて支援させていただいております。
                  </v-card>
                  <v-card class="pa-6" outlined tile>
                    現在は株式会社Lifedge様とのエンジニアベース事業及び就労支援施設COCOCARAにて、
                    <br />IT実践型教育を展開しております。

                    <ul>
                      <li>
                        <a href="https://engineerbase.jp/"
                          >Lifedge様 エンジニアベース事業</a
                        >
                      </li>
                      <li>
                        <a href="https://snabi.jp/facility/19317"
                          >就労支援施設COCOCARA</a
                        >
                      </li>
                    </ul>
                  </v-card>

                  <v-card class="pa-4" outlined tile color="#DCDCDC">
                    <b>スタートアップ支援/事業構築支援</b>
                  </v-card>
                  <v-card class="pa-6" outlined tile>
                    主に請負の新規フェーズの案件を中心とした開発を行っております。
                    <br />開発環境や多種多様なビジネス環境の中で、クライアントと直接やり取りし、
                    <br />仕事を通して共に付加価値を創出することを主軸としており、クライアントの状況も踏まえて、
                    柔軟な事業を作る上での開発サポートをさせて頂いております。
                    <br />また、自社でのサービス開発も積極的に行っております！
                  </v-card>
                  <v-card class="pa-6" outlined tile>
                    <div>
                      ■オンラインフィットネスサービス Smile
                      コロナ化における水泳事業から新たな業態転換にチャレンジするために一緒に戦っております。
                      現在はオンラインフィットネス事業に向けた仕組みづくりにトライ中で、参加者が笑顔になれるフィットネスプラットフォームを構築中！
                      <br />詳細は以下をクリック<br />
                      <a href="https://lp-smile-star.com/"
                        ><img :width="150" :src="smilelogo"
                      /></a>
                      <br />
                      <a href="http://star-swim.com/">株式会社STAR様</a>
                    </div>
                  </v-card>
                  <v-card class="pa-6" outlined tile>
                    <div>
                      ■司法書士様向け業務改善サービス
                      司法書士業界で起きている業務を簡易化するための仕組みを開発中です。
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <br /><br />
          <p class="btn-positon">
            <a href="https://forms.gle/2ee784g8o1j61e7c9" class="btn"
              >ご相談はこちら</a
            >
          </p>
          <br /><br />
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import SmileImage from "@/assets/img/smile-logo.png";
import GuerrillaLogo from "@/assets/icon_gurilla.png";
export default {
  data: function () {
    return {
      smilelogo: SmileImage,
      guerrillalogo: GuerrillaLogo,
    };
  },
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.resizeimage img {
  width: 100%;
}

table th:first-child {
  border-radius: 5px 0 0 0;
}

table th:last-child {
  border-radius: 0 5px 0 0;
  border-right: 1px solid #3c6690;
}

table th {
  text-align: center;
  color: white;
  background: linear-gradient(#829ebc, #225588);
  border-left: 1px solid #3c6690;
  border-top: 1px solid #3c6690;
  border-bottom: 1px solid #3c6690;
  box-shadow: 0px 1px 1px rgba(255, 255, 255, 0.3) inset;
  width: 25%;
  padding: 10px 0;
}

table td {
  text-align: left;
  border-left: 1px solid #a8b7c5;
  border-bottom: 1px solid #a8b7c5;
  border-top: none;
  box-shadow: 0px -3px 5px 1px #eee inset;
  width: 25%;
  padding: 10px 0;
}

table td:last-child {
  border-right: 1px solid #a8b7c5;
}

table tr:last-child td:first-child {
  border-radius: 0 0 0 5px;
}

table tr:last-child td:last-child {
  border-radius: 0 0 5px 0;
}

ul {
  padding: 0;
}
li {
  list-style-type: none;
}
dd {
  margin-left: 0;
}

.flow {
  border: 3px solid rgb(0, 0, 0);
}
.flow > li {
  padding: 30px;
}
.flow > li:not(:last-child) {
  border-bottom: 3px solid rgb(0, 0, 0);
  position: relative;
}
.flow > li:not(:last-child)::before,
.flow > li:not(:last-child)::after {
  content: "";
  border: solid transparent;
  position: absolute;
  top: 100%;
  left: 15%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
.flow > li:not(:last-child)::before {
  border-width: 22px;
  border-top-color: rgb(0, 0, 0);
}
.flow > li:not(:last-child)::after {
  border-width: 18px;
  border-top-color: #fff;
}
.flow > li dl {
  margin: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.flow > li dl dt {
  font-size: 20px;
  font-weight: 600;
  color: rgb(0, 0, 0);
  -ms-flex-preferred-size: 20%;
  flex-basis: 20%;
  margin-right: 1vw;
  text-align: center;
}
.flow > li dl dt .icon {
  font-size: 12px;
  color: #fff;
  background: rgb(0, 0, 0);
  background: -moz-linear-gradient(
    left,
    rgba(156, 156, 156, 1) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  background: -webkit-linear-gradient(
    left,
    rgba(156, 156, 156, 1) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  background: linear-gradient(
    to right,
    rgba(156, 156, 156, 1) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#6b90db', endColorstr='#66d5e9',GradientType=1 );
  padding: 5px 10px;
  margin-bottom: 10px;
  display: block;
  border-radius: 20px;
}
.btn-positon {
  text-align: center;
}

.btn-positon .btn {
  color: #ffffff;
  font-size: 24px;
  border-radius: 30px;
  font-weight: bold;
  background-color: #000;
  padding: 20px;
}

.btn-positon .btn:hover {
  opacity: 0.5;
}

.btn-positon a {
  text-decoration: none;
}
</style>